import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/institutional/index.css'
import { initGlobalErrorHandlers } from './utils/globalErrorHandlers'
import { initGTM } from './utils/gtm'

// Initialize global error handlers for auto-reload on deploy
initGlobalErrorHandlers();
initGTM()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

